// Product data for SIBR Lifescience
export const products = [
  {
    id: 'lycorib-sf-syp',
    name: 'LYCORIB - SF SYP (Available in Mixed Fruit, Mango & Pineapple)',
    category: 'pharma',
    tagline: 'Advanced Lycopene & Multivitamin Formula for Comprehensive Immune and Metabolic Support',
    shortDescription: 'Sugar-free syrup with Lycopene and essential B-vitamins for immunity and energy. Available in 3 delicious flavours.',
    image: '/assets/images/products/lycorib-sf-preview.png',
    variants: [
      { name: 'Mixed Fruit', image: '/assets/images/products/lycorib-sf-preview.png' },
      { name: 'Mango', image: '/assets/images/products/lycorib-sf-mango-preview.png' },
      { name: 'Pineapple', image: '/assets/images/products/lycorib-sf-pineapple-preview.png' }
    ],
    benefits: [
      'Robust Immune Defence: Boosts the body\'s defense system',
      'Cellular Energy: Enhances metabolic processes and reduces chronic fatigue',
      'Cardiovascular & CNS Support: Promotes healthy nerve tissue and brain function',
      'Antioxidant Protection: Fights free radicals and oxidative stress'
    ],
    ingredients: [
      { name: 'Lycopene', category: 'Antioxidant', amount: '5000 mcg' },
      { name: 'Niacinamide (B3)', category: 'B-Vitamin', amount: '50 mg' },
      { name: 'Pyridoxine (B6)', category: 'B-Vitamin', amount: '1.5 mg' },
      { name: 'Cyanocobalamin (B12)', category: 'B-Vitamin', amount: '5 mcg' },
      { name: 'Folic Acid', category: 'B-Vitamin', amount: '1.5 mg' },
      { name: 'Selenium', category: 'Mineral', amount: '35 mcg' }
    ],
    mechanism: 'The potent antioxidant Lycopene acts as a scavenger against Reactive Oxygen Species (ROS), while B-complex vitamins support the Krebs cycle to enhance cellular energy production and repair wear and tear tissues. Selenium provides additional antioxidant support for comprehensive cellular protection.',
    indications: [
      'General weakness and fatigue',
      'Immune system support',
      'Recovery from illness',
      'Antioxidant supplementation',
      'Metabolic support'
    ],
    dosage: 'As directed by the physician. Generally 10ml twice daily or as advised.',
    safety: [
      'Store in a cool, dry place away from direct sunlight',
      'Keep out of reach of children',
      'Consult a physician before use if pregnant or nursing',
      'Do not exceed recommended dosage'
    ],
    link1mg: 'https://www.1mg.com/otc/lycorib-syrup-otc726435'
  },
  {
    id: 'sasvita-capsule',
    name: 'Sasvita Capsule',
    category: 'pharma',
    tagline: 'Complete Multivitamin & Mineral Supplement',
    shortDescription: 'Comprehensive nutritional support with essential vitamins and minerals.',
    image: '/assets/images/products/sasvita-preview.png',
    benefits: [
      'Complete nutritional support',
      'Energy and vitality enhancement',
      'Immune system fortification',
      'Overall health maintenance'
    ],
    ingredients: [
      { name: 'Vitamin A', category: 'Vitamin', amount: '2500 IU' },
      { name: 'Vitamin D3', category: 'Vitamin', amount: '400 IU' },
      { name: 'Vitamin E', category: 'Vitamin', amount: '15 IU' },
      { name: 'Zinc', category: 'Mineral', amount: '15 mg' }
    ],
    mechanism: 'Provides essential micronutrients that support various metabolic processes, enzyme functions, and overall cellular health.',
    indications: [
      'Nutritional deficiency',
      'General health maintenance',
      'Convalescence'
    ],
    dosage: 'One capsule daily or as directed by physician.',
    safety: [
      'Store below 25°C',
      'Keep out of reach of children'
    ],
    link1mg: 'https://www.1mg.com/otc/sasvita-capsule-otc728785'
  },
  {
    id: 'somib-d-capsule-sr',
    name: 'Somib-D Capsule SR',
    category: 'pharma',
    tagline: 'Sustained Release Formulation for Extended Benefits',
    shortDescription: 'Sustained-release capsule for prolonged therapeutic action.',
    image: '/assets/images/products/somib-d-preview.png',
    benefits: [
      'Extended release for sustained action',
      'Improved bioavailability',
      'Convenient once-daily dosing'
    ],
    ingredients: [],
    mechanism: 'Sustained release technology ensures gradual and consistent drug release for optimal therapeutic effect.',
    indications: ['As directed by physician'],
    dosage: 'As directed by the physician.',
    safety: ['Do not crush or chew', 'Store in cool, dry place'],
    link1mg: 'https://www.1mg.com/drugs/somib-d-capsule-sr-728772'
  },
  {
    id: 'cefdoxib-50',
    name: 'Cefdoxib 50 Oral Suspension',
    category: 'pharma',
    tagline: 'Cefpodoxime Proxetil Oral Suspension',
    shortDescription: 'Broad-spectrum antibiotic suspension for pediatric and adult use.',
    image: '/assets/images/products/cefdoxib-50-preview.png',
    benefits: [
      'Broad-spectrum antibacterial activity',
      'Effective against respiratory infections',
      'Pleasant taste for better compliance'
    ],
    ingredients: [
      { name: 'Cefpodoxime Proxetil', category: 'Antibiotic', amount: '50mg/5ml' }
    ],
    mechanism: 'Third-generation cephalosporin that inhibits bacterial cell wall synthesis, providing bactericidal activity against susceptible organisms.',
    indications: [
      'Upper respiratory tract infections',
      'Lower respiratory tract infections',
      'Urinary tract infections',
      'Skin and soft tissue infections'
    ],
    dosage: 'As prescribed by physician based on age and weight.',
    safety: [
      'Complete the full course of treatment',
      'Store reconstituted suspension in refrigerator',
      'Use within 14 days after reconstitution'
    ],
    link1mg: 'https://www.1mg.com/drugs/cefdoxib-50-oral-suspension-726423'
  },
  {
    id: 'mefepra-suspension',
    name: 'Mefepra Oral Suspension',
    category: 'pharma',
    tagline: 'Analgesic and Antipyretic Suspension',
    shortDescription: 'Pain relief and fever reduction in liquid form.',
    image: '/assets/images/products/mefepra-preview.png',
    benefits: [
      'Effective pain relief',
      'Rapid fever reduction',
      'Easy to administer'
    ],
    ingredients: [],
    mechanism: 'Provides analgesic and antipyretic action through prostaglandin synthesis inhibition.',
    indications: ['Fever', 'Pain', 'Inflammatory conditions'],
    dosage: 'As directed by physician.',
    safety: ['Do not exceed recommended dose', 'Not for prolonged use without medical supervision'],
    link1mg: 'https://www.1mg.com/drugs/mefepra-oral-suspension-728788'
  },
  {
    id: 'sasmol-ap',
    name: 'Sasmol-AP Tablet',
    category: 'pharma',
    tagline: 'Analgesic and Antipyretic Combination',
    shortDescription: 'Effective combination for pain and fever management.',
    image: '/assets/images/products/sasmol-ap-preview.png',
    benefits: [
      'Dual action for pain and fever',
      'Fast-acting relief',
      'Well-tolerated formulation'
    ],
    ingredients: [],
    mechanism: 'Combination therapy provides synergistic analgesic and antipyretic effects.',
    indications: ['Headache', 'Body ache', 'Fever', 'Cold and flu symptoms'],
    dosage: 'As directed by physician.',
    safety: ['Take with food to reduce gastric irritation', 'Avoid alcohol consumption'],
    link1mg: 'https://www.1mg.com/drugs/sasmol-ap-tablet-726415'
  },
  {
    id: 'sasmox-cv-suspension',
    name: 'Sasmox-CV Oral Suspension',
    category: 'pharma',
    tagline: 'Amoxicillin + Clavulanic Acid Combination',
    shortDescription: 'Broad-spectrum antibiotic with beta-lactamase inhibitor.',
    image: '/assets/images/products/sasmox-cv-oral-suspension-preview.png',
    benefits: [
      'Extended spectrum antibacterial coverage',
      'Effective against resistant bacteria',
      'Suitable for pediatric use'
    ],
    ingredients: [
      { name: 'Amoxicillin', category: 'Antibiotic', amount: 'Various strengths' },
      { name: 'Clavulanic Acid', category: 'Beta-lactamase inhibitor', amount: 'Various strengths' }
    ],
    mechanism: 'Amoxicillin provides bactericidal activity while Clavulanic Acid inhibits beta-lactamase enzymes, restoring susceptibility in resistant bacteria.',
    indications: [
      'Respiratory tract infections',
      'Ear infections',
      'Urinary tract infections',
      'Skin infections'
    ],
    dosage: 'As prescribed by physician.',
    safety: ['Complete full course', 'Monitor for allergic reactions', 'Store properly after reconstitution'],
    link1mg: 'https://www.1mg.com/drugs/sasmox-cv-oral-suspension-728774'
  },
  {
    id: 'cefurib-500',
    name: 'Cefurib 500 Tablet',
    category: 'pharma',
    tagline: 'Cefuroxime Axetil 500mg Tablets',
    shortDescription: 'Second-generation cephalosporin for various infections.',
    image: '/assets/images/products/cefurib-500-preview.png',
    benefits: [
      'Broad-spectrum activity',
      'Effective against gram-positive and gram-negative bacteria',
      'Once or twice daily dosing'
    ],
    ingredients: [
      { name: 'Cefuroxime Axetil', category: 'Antibiotic', amount: '500mg' }
    ],
    mechanism: 'Second-generation cephalosporin that inhibits bacterial cell wall synthesis.',
    indications: [
      'Respiratory infections',
      'Skin infections',
      'Urinary tract infections'
    ],
    dosage: 'As directed by physician.',
    safety: ['Take with food for better absorption', 'Complete the course'],
    link1mg: 'https://www.1mg.com/drugs/cefurib-500-tablet-726429'
  },
  {
    id: 'sasmox-cv-tablet',
    name: 'Sasmox-CV Tablet',
    category: 'pharma',
    tagline: 'Amoxicillin + Clavulanic Acid Tablets',
    shortDescription: 'Tablet form of broad-spectrum antibiotic combination.',
    image: '/assets/images/products/sasmox-cv-preview.png',
    benefits: [
      'Convenient tablet form',
      'Extended antibacterial spectrum',
      'Effective against beta-lactamase producing bacteria'
    ],
    ingredients: [
      { name: 'Amoxicillin', category: 'Antibiotic', amount: 'Various strengths' },
      { name: 'Clavulanic Acid', category: 'Beta-lactamase inhibitor', amount: 'Various strengths' }
    ],
    mechanism: 'Combination therapy overcomes bacterial resistance mechanisms for broader coverage.',
    indications: ['Various bacterial infections as prescribed by physician'],
    dosage: 'As directed by physician.',
    safety: ['Take at regular intervals', 'Do not skip doses'],
    link1mg: 'https://www.1mg.com/drugs/sasmox-cv-tablet-726426'
  },
  {
    id: 'cefdoxib-200-dt',
    name: 'Cefdoxib 200 Tablet DT',
    category: 'pharma',
    tagline: 'Dispersible Cefpodoxime Proxetil Tablets',
    shortDescription: 'Dispersible antibiotic tablets for easy administration.',
    image: '/assets/images/products/cefdoxib-200-tab-preview.png',
    benefits: [
      'Dispersible formulation for easy intake',
      'Effective broad-spectrum coverage',
      'Improved compliance'
    ],
    ingredients: [
      { name: 'Cefpodoxime Proxetil', category: 'Antibiotic', amount: '200mg' }
    ],
    mechanism: 'Third-generation cephalosporin with excellent oral bioavailability.',
    indications: ['Bacterial infections as prescribed'],
    dosage: 'Disperse in water before taking. As directed by physician.',
    safety: ['Take with food', 'Complete the prescribed course'],
    link1mg: 'https://www.1mg.com/drugs/cefdoxib-200-tablet-dt-726418'
  },
  // Star Division Products
  {
    id: 'irosib-z-syp',
    name: 'Irosib-Z Syrup',
    category: 'star',
    tagline: 'Iron & Zinc Supplement Syrup',
    shortDescription: 'Nutritional supplement syrup with essential iron and zinc for overall health.',
    image: '/assets/images/products/Irosib_-_Z_Syp-preview.png',
    benefits: [
      'Supports healthy hemoglobin levels',
      'Boosts immune system function',
      'Promotes overall growth and development',
      'Easy-to-take liquid formulation'
    ],
    ingredients: [
      { name: 'Iron', category: 'Mineral', amount: 'As formulated' },
      { name: 'Zinc', category: 'Mineral', amount: 'As formulated' }
    ],
    mechanism: 'Iron is essential for hemoglobin formation and oxygen transport, while Zinc supports immune function, wound healing, and cellular metabolism.',
    indications: [
      'Iron deficiency anemia',
      'Nutritional supplementation',
      'Growth support in children',
      'General weakness and fatigue'
    ],
    dosage: 'As directed by the physician.',
    safety: [
      'Store in a cool, dry place',
      'Keep out of reach of children',
      'Shake well before use'
    ],
    link1mg: ''
  },
  {
    id: 'montisib-lc-tab',
    name: 'Montisib-LC Tablet',
    category: 'star',
    tagline: 'Montelukast 10mg + Levocetirizine 5mg Anti-Allergic Combination',
    shortDescription: 'Combination medicine for allergic symptoms including runny nose, sneezing, and itching.',
    image: '/assets/images/products/Montisib_-LC_tab-preview.png',
    benefits: [
      'Relieves allergic rhinitis symptoms',
      'Reduces sneezing and runny nose',
      'Controls itching and watery eyes',
      'Provides relief from nasal congestion'
    ],
    ingredients: [
      { name: 'Montelukast', category: 'Leukotriene Receptor Antagonist', amount: '10mg' },
      { name: 'Levocetirizine', category: 'Antihistamine', amount: '5mg' }
    ],
    mechanism: 'Montelukast blocks leukotrienes which cause inflammation and allergic symptoms, while Levocetirizine is a selective H1 antihistamine that blocks histamine-mediated allergic responses. Together they provide comprehensive relief from allergic symptoms.',
    indications: [
      'Allergic rhinitis',
      'Runny nose and sneezing',
      'Itching and watery eyes',
      'Nasal congestion and stuffiness',
      'Seasonal allergies'
    ],
    dosage: 'One tablet once daily or as directed by physician.',
    safety: [
      'May cause drowsiness - avoid driving if affected',
      'Store in a cool, dry place',
      'Not recommended during pregnancy without medical advice'
    ],
    link1mg: ''
  },
  {
    id: 'pantosib-dsr-cap',
    name: 'Pantosib-DSR Capsule',
    category: 'star',
    tagline: 'Pantoprazole 40mg + Domperidone 30mg SR Gastro-Protective Combination',
    shortDescription: 'ALU-ALU packed capsules for acid reflux and digestive comfort.',
    image: '/assets/images/products/PANTOSIB-DSR_CAP-preview.png',
    benefits: [
      'Reduces stomach acid production',
      'Relieves heartburn and acid reflux',
      'Prevents nausea and vomiting',
      'Promotes gastric motility'
    ],
    ingredients: [
      { name: 'Pantoprazole', category: 'Proton Pump Inhibitor', amount: '40mg' },
      { name: 'Domperidone SR', category: 'Prokinetic Agent', amount: '30mg' }
    ],
    mechanism: 'Pantoprazole irreversibly inhibits the proton pump in gastric parietal cells, reducing acid secretion. Domperidone SR (sustained release) acts as a dopamine antagonist, enhancing gastric motility and reducing nausea.',
    indications: [
      'Gastroesophageal reflux disease (GERD)',
      'Peptic ulcer disease',
      'Nausea and vomiting',
      'Dyspepsia and bloating'
    ],
    dosage: 'One capsule once daily before breakfast or as directed by physician.',
    safety: [
      'Take on empty stomach for best results',
      'ALU-ALU packing ensures stability',
      'Do not crush or chew the capsule'
    ],
    link1mg: ''
  },
  {
    id: 'aclosib-sp-tab',
    name: 'Aclosib-SP Tablet',
    category: 'star',
    tagline: 'Aceclofenac 100mg + Paracetamol 325mg + Serratiopeptidase 15mg Triple Action',
    shortDescription: 'ALU-ALU packed tablets for pain, inflammation, and swelling relief.',
    image: '/assets/images/products/ACLOSIB-SP_TAB-preview.png',
    benefits: [
      'Powerful pain relief',
      'Reduces inflammation and swelling',
      'Enzyme-enhanced anti-inflammatory action',
      'Faster recovery from injuries'
    ],
    ingredients: [
      { name: 'Aceclofenac', category: 'NSAID', amount: '100mg' },
      { name: 'Paracetamol', category: 'Analgesic/Antipyretic', amount: '325mg' },
      { name: 'Serratiopeptidase', category: 'Proteolytic Enzyme', amount: '15mg' }
    ],
    mechanism: 'Aceclofenac inhibits COX enzymes reducing prostaglandin synthesis and inflammation. Paracetamol provides central analgesic and antipyretic action. Serratiopeptidase is a proteolytic enzyme that breaks down inflammatory proteins, reducing swelling and promoting tissue healing.',
    indications: [
      'Musculoskeletal pain and inflammation',
      'Post-operative pain and swelling',
      'Dental pain',
      'Arthritis and joint pain',
      'Sports injuries'
    ],
    dosage: 'One tablet twice daily after meals or as directed by physician.',
    safety: [
      'Take after food to reduce gastric irritation',
      'ALU-ALU packing ensures product stability',
      'Avoid in patients with gastric ulcers'
    ],
    link1mg: ''
  },
  {
    id: 'aclosib-p-tab',
    name: 'Aclosib-P Tablet',
    category: 'star',
    tagline: 'Aceclofenac 100mg + Paracetamol 325mg Pain Relief Combination',
    shortDescription: 'Blister packed tablets for effective pain and fever management.',
    image: '/assets/images/products/ACLOSIB_-_P_TAB-preview.png',
    benefits: [
      'Effective pain relief',
      'Reduces fever and inflammation',
      'Well-tolerated formulation',
      'Convenient blister packing'
    ],
    ingredients: [
      { name: 'Aceclofenac', category: 'NSAID', amount: '100mg' },
      { name: 'Paracetamol', category: 'Analgesic/Antipyretic', amount: '325mg' }
    ],
    mechanism: 'Aceclofenac provides anti-inflammatory and analgesic action by inhibiting prostaglandin synthesis, while Paracetamol acts centrally to reduce pain perception and lower body temperature in fever.',
    indications: [
      'Mild to moderate pain',
      'Fever',
      'Headache and body ache',
      'Dental pain',
      'Musculoskeletal pain'
    ],
    dosage: 'One tablet twice daily after meals or as directed by physician.',
    safety: [
      'Take with food',
      'Avoid alcohol consumption',
      'Not for prolonged use without medical supervision'
    ],
    link1mg: ''
  },
  {
    id: 'sascal-hd',
    name: 'Sascal-HD Tablet',
    category: 'pharma',
    tagline: 'Calcium & Vitamin D3 Supplement',
    shortDescription: 'High-dose calcium and vitamin D3 supplement for bone health and calcium deficiency.',
    image: '/assets/images/products/sascal-hd-preview.png',
    benefits: [
      'Supports strong bones and teeth',
      'Helps prevent osteoporosis',
      'Aids calcium absorption with Vitamin D3',
      'Supports muscle function'
    ],
    ingredients: [
      { name: 'Calcium', category: 'Mineral', amount: 'As formulated' },
      { name: 'Vitamin D3', category: 'Vitamin', amount: 'As formulated' }
    ],
    mechanism: 'Calcium is essential for bone formation and maintenance, while Vitamin D3 enhances calcium absorption from the intestine and helps maintain proper calcium levels in the blood.',
    indications: [
      'Calcium deficiency',
      'Osteoporosis prevention',
      'Bone health support',
      'Pregnancy and lactation',
      'Growing children'
    ],
    dosage: 'As directed by the physician.',
    safety: [
      'Take with meals for better absorption',
      'Store in a cool, dry place',
      'Keep out of reach of children'
    ],
    link1mg: ''
  },
  {
    id: 'tazosib-inj',
    name: 'Tazosib Injection',
    category: 'pharma',
    tagline: 'Piperacillin + Tazobactam Antibiotic Injection',
    shortDescription: 'Broad-spectrum injectable antibiotic combination for serious bacterial infections.',
    image: '/assets/images/products/tazosib-inj-preview.png',
    benefits: [
      'Broad-spectrum antibacterial activity',
      'Effective against resistant bacteria',
      'Beta-lactamase inhibitor combination',
      'Hospital-grade antibiotic'
    ],
    ingredients: [
      { name: 'Piperacillin', category: 'Antibiotic', amount: 'As formulated' },
      { name: 'Tazobactam', category: 'Beta-lactamase inhibitor', amount: 'As formulated' }
    ],
    mechanism: 'Piperacillin is a broad-spectrum penicillin antibiotic that inhibits bacterial cell wall synthesis. Tazobactam is a beta-lactamase inhibitor that protects piperacillin from degradation by bacterial enzymes, extending its spectrum of activity.',
    indications: [
      'Severe bacterial infections',
      'Hospital-acquired pneumonia',
      'Intra-abdominal infections',
      'Skin and soft tissue infections',
      'Febrile neutropenia'
    ],
    dosage: 'As directed by the physician. For intravenous administration only.',
    safety: [
      'For hospital/clinical use only',
      'Administer under medical supervision',
      'Monitor for allergic reactions',
      'Store as per package instructions'
    ],
    link1mg: ''
  }
]

import { productDefaults, seoConfig } from '../config/siteConfig'

/**
 * Get a product by ID (only if enabled)
 * Returns null if product is disabled
 */
export const getProductById = (id) => {
  const product = products.find(product => product.id === id)
  if (!product) return null
  // Check if product is enabled (default to true if not specified)
  const isEnabled = product.enabled ?? productDefaults.enabled
  return isEnabled ? product : null
}

/**
 * Get all enabled products
 */
export const getEnabledProducts = () => {
  return products.filter(product => product.enabled ?? productDefaults.enabled)
}

/**
 * Get all SEO-enabled products (for sitemap)
 */
export const getSeoEnabledProducts = () => {
  if (!seoConfig.globalSeoEnabled) return []
  return products.filter(product => {
    const isEnabled = product.enabled ?? productDefaults.enabled
    const isSeoEnabled = product.seoEnabled ?? productDefaults.seoEnabled
    return isEnabled && isSeoEnabled
  })
}

/**
 * Check if a product has SEO enabled
 */
export const isProductSeoEnabled = (product) => {
  if (!seoConfig.globalSeoEnabled) return false
  if (!product) return false
  const isEnabled = product.enabled ?? productDefaults.enabled
  const isSeoEnabled = product.seoEnabled ?? productDefaults.seoEnabled
  return isEnabled && isSeoEnabled
}

